module.exports = __webpack_public_path__ + "assets/imgs/gmp/gmp-optimize.1801f64991b0fcec3b9bf0561789bd1d.png";